import { Component, OnInit, Input } from '@angular/core';
import { InformacaoService } from 'src/app/service/informacao/informacao.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'cartorios-extrajudiciais-capital-informacao',
  templateUrl: './cartorios-extrajudiciais-capital-informacao.component.html',
  styleUrls: ['./cartorios-extrajudiciais-capital-informacao.component.css']
})
export class CartoriosExtrajudiciaisCapitalInformacaoComponent implements OnInit {

  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  listaClassificacaoComponente = [];
  municipio: any;
  cartorioComponente: any;
  localidade: any[];
  localidadeStr: String = '';
  listaMunicipio: any[];
  @Input() cartoriosFiltrados: any[];
  charNum = 5000;

  constructor(
    public service: InformacaoService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) {
  }

  ngOnInit() {

    this.preencherListaClassificacao();
    this.preencherListaMunicipio();

    if (!this.visualizacao && !this.edicao) {

      this.service.informacao.controls.descricaoInformacao.setValue('');
      this.service.informacao.controls.municipio.setValue('');
      this.service.informacao.controls.cartorio.setValue('');

    } else {

      this.cartoriosFiltrados = this.service.informacao.value.listaCartorio
      .filter(cartorio => cartorio.id.municipio.nome === this.service.informacao.controls.municipio.value);

    }

  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.informacao.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.informacao.value.assunto.id);
  }

  preencherListaMunicipio() {
    this.listaMunicipio = this.service.informacao.value.listaCartorio.map(
      cartorio => cartorio.id.municipio.nome);
    return (this.listaMunicipio = [...new Set(this.listaMunicipio)].sort());
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.informacao.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.informacao.controls[str].touched &&
      this.service.informacao.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  filtrarCartorios() {

    this.cartoriosFiltrados = this.service.informacao.value.listaCartorio
    .filter(cartorio => cartorio.id.municipio.nome === this.service.informacao.controls.municipio.value);

    this.cartoriosFiltrados.sort((cartorio1, cartorio2) =>
      (cartorio1.nomeServico > cartorio2.nomeServico ? 1 : -1));

    this.service.informacao.controls.localidade.setValue('');
    this.service.informacao.controls.cartorio.setValue('');
    this.service.informacao.controls.cartorio.enable();

  }

  preencherLocalicade() {

    const localidade = this.service.informacao.value.listaCartorio
      .find(cartorio => cartorio.nomeServico === this.service.informacao.controls.cartorio.value && cartorio.id.municipio.nome === this.service.informacao.controls.municipio.value);

    this.localidadeStr = localidade ?
      (localidade.tLogCodigo ? (localidade.tLogCodigo + '. ') : '') +
      (localidade.nomeLogradouro ? (localidade.nomeLogradouro + ', ') : '') +
      (localidade.numeroLogradouro ? (localidade.numeroLogradouro + ', ') : '') +
      (localidade.complementoLogradouro ? (localidade.complementoLogradouro + ', ') : '') +
      (localidade.bairro ? (localidade.bairro) : '') : null;

    return this.service.informacao.controls.localidade.setValue(this.localidadeStr);

  }

}
